<div class="button-container">
  <div class="update-button-text">Update mode:</div>
  <button
    class="update-button"
    #updateMenuTrigger="matMenuTrigger"
    aria-label="Update"
    [class.open]="updateMenuTrigger.menuOpen"
    [matMenuTriggerFor]="updateMenu"
  >
    <span class="update-button-type-text"> {{ isAutoUpdate ? 'Automatic' : 'Manual' }}</span>
    <capra-icon icon="icon-caret-down"></capra-icon>
  </button>
  <mat-menu #updateMenu="matMenu" class="select-menu update-menu">
    <button mat-menu-item [class.selected]="isAutoUpdate" (click)="enableAutomaticUpdates()">
      <capra-icon icon="icon-dot-indicator" *ngIf="isAutoUpdate"></capra-icon>
      Automatic
    </button>
    <button mat-menu-item [class.selected]="!isAutoUpdate" (click)="enableManualUpdates()">
      <capra-icon icon="icon-dot-indicator" *ngIf="!isAutoUpdate"></capra-icon>
      Manual
    </button>
  </mat-menu>
</div>
